import { TEST_ELEMENT_IDS } from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { memo } from 'react';
import styled from 'styled-components';

import { InlineLoaderAnimationStyles } from './InlineLoader.styles';

interface Props {
	className?: string;
	withoutBackground?: boolean;
}

const InlineLoader = ({ className }: Props) => {
	return (
		<div data-testid={TEST_ELEMENT_IDS.ADMIN_LOADER} className={className}>
			<InlineLoaderAnimationStyles>
				<svg
					viewBox="0 50 160 60"
					xmlns="http://www.w3.org/2000/svg"
					preserveAspectRatio="xMidYMid meet"
				>
					<rect
						className="box box-1"
						x="9.945"
						y="64"
						width="32"
						height="32"
						rx="8"
						fill="#959E9E"
					/>
					<rect
						className="box box-2"
						x="46.055"
						y="64"
						width="32"
						height="32"
						rx="8"
						fill="#959E9E"
					/>
					<rect
						className="box box-3"
						x="82.055"
						y="64"
						width="32"
						height="32"
						rx="8"
						fill="#959E9E"
					/>
					<rect
						className="box box-4"
						x="118.055"
						y="64"
						width="32"
						height="32"
						rx="8"
						fill="#959E9E"
					/>
				</svg>
			</InlineLoaderAnimationStyles>
		</div>
	);
};

const Memoized = memo(InlineLoader);
const Styled = styled(Memoized)`
	position: absolute;
	cursor: wait;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 100;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	${({ withoutBackground }) => !withoutBackground && `background-color: #ffffffd9;`}
`;

export { Styled as InlineLoader };
